import { createContext } from 'react';

interface ITryForFreeCtaContextValue {
    isCtaTest?: boolean;
    customCtaText?: string;
}

export const TryForFreeCtaContext = createContext(
    {} as ITryForFreeCtaContextValue
);
